var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.list.length)?_c('div',{staticClass:"input-helpers"},_vm._l((_vm.list),function(el,key){return _c('div',{key:key,staticClass:"input-helpers__el",on:{"click":function($event){return _vm.$emit('inputHelpersChange', {
                name: _vm.inputName,
                value: el
            })}}},[_vm._v(" "+_vm._s(el.value)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }